const ACL_KINDS_BY_SERVICE = {
  Elasticsearch: [
    { kind: 2, label: 'Elasticsearch' },
    { kind: 4, label: 'Kibana' },
    { kind: 5, label: 'Cerebro' },
  ],
  CockroachDB: [
    { kind: 6, label: 'CockroachDB' },
    { kind: 7, label: 'CockroachDB Admin UI' },
  ],
  PostgreSQL: [
    { kind: 8, label: 'PostgreSQL Master' },
    { kind: 9, label: 'PostgreSQL Replica' },
  ],
  TimescaleDB: [
    { kind: 10, label: 'TimescaleDB Master' },
    { kind: 11, label: 'TimescaleDB Replica' },
  ],
};

const DEFAULT_ACL_KIND = [{ kind: 1, label: 'Default' }];

/**
 * Returns the list of ACL Kinds for a service. Prefer this for future usage over the ACL_KINDS
 * constant as it's easier to use for a lookup than doing a bunch of complicated filtering over
 * an object. Refactor other places where ACL_KINDS is used as desired.
 *
 * @param {string} service - Current state
 * @returns {array} - list of available ACL Kinds
 */
export function getAclKindsByService(service) {
  return ACL_KINDS_BY_SERVICE[service] || DEFAULT_ACL_KIND;
}

export default getAclKindsByService;
